
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33950',
  depVersions: {
  "documents-public-ui": "static-1.33950",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33955",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1916",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5382",
  "hs-test-utils": "static-1.7796",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11215",
  "I18n": "static-7.1565",
  "jasmine-immutable": "static-1.2808",
  "jasmine-runner": "static-1.6264",
  "lodash": "static-1.3",
  "quartz": "static-1.6722",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16439",
  "reporting-data": "static-1.66476",
  "reporting-testing-lib": "static-1.8409",
  "reporting-visualizations": "static-1.58552",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4556",
  "webpack-env": "static-1.54",
  "atom": "static-1.4860",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2276",
  "classnames": "static-2.10",
  "cssUtils": "static-1.727",
  "customer-data-filters-ui": "static-1.38878",
  "customer-data-objects": "static-1.7437",
  "customer-data-property-utils": "static-1.7867",
  "data-fetching-client": "static-1.9469",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4320",
  "flux-actions": "static-1.307",
  "FormsCommonComponents": "static-1.85266",
  "FormUrlGenerator": "static-2.4520",
  "foundations-components": "static-1.7507",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11523",
  "icons": "static-2.621",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6952",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3649",
  "property-translator": "static-1.5203",
  "quartz-config": "static-1.500",
  "quartz-core": "static-1.5941",
  "quick-fetch": "static-1.3726",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5164",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7952",
  "reference-resolvers-lite": "static-1.7885",
  "report-customization-components": "static-1.12476",
  "reporting-enablement": "static-1.22045",
  "reporting-reports": "static-1.66154",
  "reporting-snowflake": "static-1.55094",
  "reporting-ui-components": "static-2.63747",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4423",
  "sales-content-partitioning": "static-1.8725",
  "SalesContentIndexUI": "static-3.8890",
  "sanitize": "static-1.4265",
  "sanitize-text": "static-1.7930",
  "self-service-api": "static-1.10025",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1544",
  "signup-constants": "static-1.18370",
  "signup-ui-lego-core": "static-1.20380",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4561",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10785",
  "ui-addon-i18n": "static-1.10928",
  "ui-addon-react-router-dom": "static-1.9338",
  "ui-addon-upgrades": "static-9.17641",
  "ui-asset-management-lib": "static-1.10698",
  "ui-images": "static-2.1088",
  "UIComponents": "static-3.8162",
  "usage-tracker": "static-1.7124",
  "usage-tracker-container": "static-1.7114",
  "usage-tracker-core": "static-1.6974",
  "usage-tracker-public": "static-1.6935",
  "viral-links-lib": "static-1.6823",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3219",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2999",
  "quartz-webpack": "static-1.2946",
  "ai-components-ui-library": "static-1.8328",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4627",
  "foundations-theming": "static-1.4200",
  "quartz-auth": "static-1.397",
  "ui-business-units-lib": "static-1.8817",
  "usage-tracker-session-replay": "static-1.4810",
  "foundations-theming-base": "static-1.3185",
  "HeadJS": "static-2.707",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2907",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4118",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7715",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3408",
  "persist-promise": "static-1.3497",
  "reporting-client-types": "static-1.2385",
  "foundations-components-legacy": "static-1.532",
  "hs-story-utils": "static-1.9219",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9460",
  "hubspotter-http": "static-1.4469",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7038",
  "crm-message-bus": "static-1.42341",
  "customer-data-filters-ui-msw-helpers": "static-1.21312",
  "customer-data-objects-ui-components": "static-1.12796",
  "customer-data-reference-ui-components": "static-1.12933",
  "customer-data-ui-utilities": "static-1.9615",
  "framework-builder-read-service-client": "static-1.3824",
  "framework-data-schema-quick-fetch": "static-1.6568",
  "framework-data-schema-resolvers": "static-1.6663",
  "inbound-db-properties-service-client": "static-1.3666",
  "multi-account-reference-resolvers": "static-1.764",
  "onboarding-tours": "static-1.16245",
  "reporting-datasets-permissions-lib": "static-1.13015",
  "ui-addon-teams": "static-1.21230",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67597",
  "customer-data-properties": "static-1.50781",
  "forms-ai-lib": "static-1.3997",
  "forms-utils-lib": "static-1.12153",
  "foundations-components-test-utils": "static-1.4990",
  "react-dnd-compat": "static-1.4412",
  "react-tinymce": "static-1.54595",
  "tinymce-config": "static-2.53721",
  "ui-gdpr-components": "static-1.10137",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3776",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1168",
  "ui-fonts": "static-1.477",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.790",
  "mobile-manifest-mixins": "static-1.480",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.387",
  "quartz-i18n": "static-1.397",
  "quartz-routing": "static-1.152",
  "quartz-test": "static-1.397",
  "quartz-tracking": "static-1.101",
  "batch-promise": "static-1.1340",
  "external-options-client-types": "static-1.3975",
  "react-colorpicker": "static-2.10001",
  "copilot-toolkit": "static-1.10503",
  "data-quality-ui-library": "static-1.12299",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40636",
  "reporting-insights-lib": "static-1.1137",
  "reporting-plugins": "static-1.9972",
  "ui-addon-draggable-compat": "static-2.4043",
  "ui-addon-opt": "static-4.8175",
  "ui-shepherd-react": "static-3.9935",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24707",
  "hubspot-apollo-client": "static-1.4671",
  "sales-templates-service-types-lib": "static-1.3982",
  "merchandise-lib": "static-1.259",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5472",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3894",
  "timezone-utils": "static-2.5035",
  "bender-build-tools": "static-1.2937",
  "chatspot-core": "static-1.20266",
  "chirp-fetch": "static-1.1674",
  "bend-plugin-foundations-theming": "static-1.2683",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9458",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3614",
  "crm-pipelines-api-client-types": "static-1.3955",
  "multi-currency-client-types": "static-1.3508",
  "getting-started-shared-tasks": "static-1.17861",
  "growth-data-modal": "static-1.5144",
  "growth-onboarding-confetti": "static-1.2861",
  "growth-onboarding-next-action-utils": "static-1.1291",
  "navigation-components": "static-1.17239",
  "onboarding-tours-client": "static-1.4459",
  "onboarding-tours-utils": "static-1.311",
  "ui-shepherd-tracker": "static-1.7316",
  "ui-universal-auth": "static-1.8682",
  "user-context": "static-1.4887",
  "cms-field-types": "static-1.4596",
  "content-icons-ui": "static-1.2149",
  "integrations-lib": "static-1.15387",
  "calling-global-api": "static-1.63633",
  "calling-internal-common": "static-1.31082",
  "calling-lifecycle-internal": "static-1.65015",
  "calling-lifecycle-messages": "static-1.57309",
  "commerce-products-lib": "static-1.8840",
  "crm-links": "static-1.6054",
  "file-manager-components": "static-1.22861",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.468",
  "inbounddb-objects-service-types": "static-1.4040",
  "meetings-icalendar-utils-lib": "static-1.423",
  "object-builder-ui-client": "static-1.47944",
  "pipeline-validation-client-types": "static-1.3777",
  "property-value-citations": "static-1.1395",
  "pulse": "static-1.299",
  "smart-property-lib": "static-1.5880",
  "tiered-pricing": "static-1.818",
  "ui-addon-iframeable": "static-1.8836",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19456",
  "tinymce-themes": "static-1.55691",
  "data-token-picker": "static-1.16028",
  "hub-http-contrib": "static-1.2835",
  "interframe": "static-3.4581",
  "tinymce-data": "static-1.39806",
  "tinymce-plugins": "static-1.56835",
  "ui-addon-sales-email": "static-1.5004",
  "magpie-lib": "static-1.5385",
  "magpie-types": "static-1.4845",
  "simple-logging-lib": "static-1.2840",
  "content-assistance-lib": "static-1.7436",
  "dashboard-lib": "static-1.80591",
  "ExportDialog": "static-6.10177",
  "hubspot-prosemirror": "static-1.17584",
  "hubspot-prosemirror-plugins": "static-1.17576",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8482",
  "campaign-roi-lib": "static-1.8251",
  "feedback-loader": "static-1.28839",
  "onboarding-scopes": "static-1.6253",
  "apollo-link-hub-http": "static-2.4439",
  "hubspot-apollo-cache": "static-1.130",
  "growth-monetization-service-types": "static-1.4305",
  "nav-client-types": "static-1.2147",
  "purchase-motions-api": "static-1.5475",
  "trials-service-types": "static-1.3706",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.516",
  "unified-auth-core-lib": "static-1.477",
  "getting-started-shared-tasks-store": "static-1.16979",
  "integrations-error-boundary-lib": "static-1.12802",
  "integrations-tracking-lib": "static-1.5379",
  "native-integrations-shared-strings": "static-1.7578",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10163",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31088",
  "shared-worker-versioning": "static-1.10827",
  "calling-usage-tracker": "static-1.6329",
  "voice-sms-access-library": "static-1.222",
  "customer-data-tracking": "static-1.6671",
  "products-iframe-lib": "static-1.7290",
  "products-ui-components-shared-msw-handlers": "static-1.9842",
  "location-customization-utils-lib": "static-1.8535",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3944",
  "video-components-external": "static-1.10539",
  "video-data-lib": "static-1.34197",
  "directed-graph": "static-1.727",
  "event-emitter": "static-1.737",
  "breeze-intelligence-kit": "static-1.5309",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9543",
  "fsm": "static-1.3521",
  "policy-lib": "static-1.6576",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9606",
  "navigation-messaging": "static-1.6566",
  "FileManagerLib": "static-1.38501",
  "NamespacedHubStyle": "static-2.8887",
  "FileManagerCore": "static-1.38360",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12019",
  "layout-dnd-utils": "static-1.10994",
  "react-codemirror": "static-1.10417",
  "ui-addon-emoji-picker": "static-1.9679",
  "ui-brand-identity-lib": "static-1.13848",
  "ui-addon-video-player": "static-1.8485",
  "ui-coaching-tips": "static-1.27922",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8359",
  "payment-link-components": "static-1.22921",
  "EmailSignatureEditor": "static-1.23892",
  "eligibility-engine-service-types": "static-1.2987",
  "universal-page-editor-lib": "static-1.2790",
  "calling-orchestration-schema": "static-1.34999",
  "sales-views-client-types": "static-1.4080",
  "crm-record-cards-service-types": "static-1.3443",
  "content-media-composition-data-lib": "static-1.11422",
  "content-media-compositions": "static-2.15429",
  "media-bridge-lib": "static-1.18550",
  "trellis-story-utils": "static-1.4313",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5600",
  "FileManagerImages": "static-1.36012",
  "video-components": "static-1.12542",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4323",
  "video-embed": "static-1.35031",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67672",
  "layout-data-lib": "static-1.9319",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6375",
  "commerce-tours-lib": "static-1.5707",
  "growth-onboarding-reliability": "static-1.4877",
  "sales-checkout-service-client": "static-1.3462",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21294",
  "sales-email-signature-service-client": "static-1.3635",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21303",
  "outpost": "static-1.3996",
  "advanced-menus-core": "static-1.14801",
  "advanced-menus-lib": "static-1.11776",
  "ui-memberships-settings-lib": "static-1.33405",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14800",
  "simple-menus-lib": "static-1.16317"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33950",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33955",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1916",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5382",
  "hs-test-utils": "/hs-test-utils/static-1.7796",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11215",
  "I18n": "/I18n/static-7.1565",
  "jasmine-immutable": "/jasmine-immutable/static-1.2808",
  "jasmine-runner": "/jasmine-runner/static-1.6264",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6722",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16439",
  "reporting-data": "/reporting-data/static-1.66476",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8409",
  "reporting-visualizations": "/reporting-visualizations/static-1.58552",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4556",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4860",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2276",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.727",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38878",
  "customer-data-objects": "/customer-data-objects/static-1.7437",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7867",
  "data-fetching-client": "/data-fetching-client/static-1.9469",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4320",
  "flux-actions": "/flux-actions/static-1.307",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85266",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4520",
  "foundations-components": "/foundations-components/static-1.7507",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11523",
  "icons": "/icons/static-2.621",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6952",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3649",
  "property-translator": "/property-translator/static-1.5203",
  "quartz-config": "/quartz-config/static-1.500",
  "quartz-core": "/quartz-core/static-1.5941",
  "quick-fetch": "/quick-fetch/static-1.3726",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5164",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7952",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7885",
  "report-customization-components": "/report-customization-components/static-1.12476",
  "reporting-enablement": "/reporting-enablement/static-1.22045",
  "reporting-reports": "/reporting-reports/static-1.66154",
  "reporting-snowflake": "/reporting-snowflake/static-1.55094",
  "reporting-ui-components": "/reporting-ui-components/static-2.63747",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4423",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8725",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8890",
  "sanitize": "/sanitize/static-1.4265",
  "sanitize-text": "/sanitize-text/static-1.7930",
  "self-service-api": "/self-service-api/static-1.10025",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1544",
  "signup-constants": "/signup-constants/static-1.18370",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20380",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4561",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10785",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10928",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9338",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17641",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10698",
  "ui-images": "/ui-images/static-2.1088",
  "UIComponents": "/UIComponents/static-3.8162",
  "usage-tracker": "/usage-tracker/static-1.7124",
  "usage-tracker-container": "/usage-tracker-container/static-1.7114",
  "usage-tracker-core": "/usage-tracker-core/static-1.6974",
  "usage-tracker-public": "/usage-tracker-public/static-1.6935",
  "viral-links-lib": "/viral-links-lib/static-1.6823",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3219",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2999",
  "quartz-webpack": "/quartz-webpack/static-1.2946",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8328",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4627",
  "foundations-theming": "/foundations-theming/static-1.4200",
  "quartz-auth": "/quartz-auth/static-1.397",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8817",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4810",
  "foundations-theming-base": "/foundations-theming-base/static-1.3185",
  "HeadJS": "/HeadJS/static-2.707",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2907",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4118",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7715",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3408",
  "persist-promise": "/persist-promise/static-1.3497",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.532",
  "hs-story-utils": "/hs-story-utils/static-1.9219",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9460",
  "hubspotter-http": "/hubspotter-http/static-1.4469",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7038",
  "crm-message-bus": "/crm-message-bus/static-1.42341",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21312",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12796",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12933",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9615",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3824",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6568",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6663",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3666",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.764",
  "onboarding-tours": "/onboarding-tours/static-1.16245",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13015",
  "ui-addon-teams": "/ui-addon-teams/static-1.21230",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67597",
  "customer-data-properties": "/customer-data-properties/static-1.50781",
  "forms-ai-lib": "/forms-ai-lib/static-1.3997",
  "forms-utils-lib": "/forms-utils-lib/static-1.12153",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4990",
  "react-dnd-compat": "/react-dnd-compat/static-1.4412",
  "react-tinymce": "/react-tinymce/static-1.54595",
  "tinymce-config": "/tinymce-config/static-2.53721",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10137",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3776",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1168",
  "ui-fonts": "/ui-fonts/static-1.477",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.790",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.480",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.387",
  "quartz-i18n": "/quartz-i18n/static-1.397",
  "quartz-routing": "/quartz-routing/static-1.152",
  "quartz-test": "/quartz-test/static-1.397",
  "quartz-tracking": "/quartz-tracking/static-1.101",
  "batch-promise": "/batch-promise/static-1.1340",
  "external-options-client-types": "/external-options-client-types/static-1.3975",
  "react-colorpicker": "/react-colorpicker/static-2.10001",
  "copilot-toolkit": "/copilot-toolkit/static-1.10503",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12299",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40636",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1137",
  "reporting-plugins": "/reporting-plugins/static-1.9972",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4043",
  "ui-addon-opt": "/ui-addon-opt/static-4.8175",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9935",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24707",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4671",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3982",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5472",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3894",
  "timezone-utils": "/timezone-utils/static-2.5035",
  "bender-build-tools": "/bender-build-tools/static-1.2937",
  "chatspot-core": "/chatspot-core/static-1.20266",
  "chirp-fetch": "/chirp-fetch/static-1.1674",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2683",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9458",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3614",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3955",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3508",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17861",
  "growth-data-modal": "/growth-data-modal/static-1.5144",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2861",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1291",
  "navigation-components": "/navigation-components/static-1.17239",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4459",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.311",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7316",
  "ui-universal-auth": "/ui-universal-auth/static-1.8682",
  "user-context": "/user-context/static-1.4887",
  "cms-field-types": "/cms-field-types/static-1.4596",
  "content-icons-ui": "/content-icons-ui/static-1.2149",
  "integrations-lib": "/integrations-lib/static-1.15387",
  "calling-global-api": "/calling-global-api/static-1.63633",
  "calling-internal-common": "/calling-internal-common/static-1.31082",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65015",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57309",
  "commerce-products-lib": "/commerce-products-lib/static-1.8840",
  "crm-links": "/crm-links/static-1.6054",
  "file-manager-components": "/file-manager-components/static-1.22861",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.468",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4040",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.423",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47944",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3777",
  "property-value-citations": "/property-value-citations/static-1.1395",
  "pulse": "/pulse/static-1.299",
  "smart-property-lib": "/smart-property-lib/static-1.5880",
  "tiered-pricing": "/tiered-pricing/static-1.818",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8836",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19456",
  "tinymce-themes": "/tinymce-themes/static-1.55691",
  "data-token-picker": "/data-token-picker/static-1.16028",
  "hub-http-contrib": "/hub-http-contrib/static-1.2835",
  "interframe": "/interframe/static-3.4581",
  "tinymce-data": "/tinymce-data/static-1.39806",
  "tinymce-plugins": "/tinymce-plugins/static-1.56835",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5004",
  "magpie-lib": "/magpie-lib/static-1.5385",
  "magpie-types": "/magpie-types/static-1.4845",
  "simple-logging-lib": "/simple-logging-lib/static-1.2840",
  "content-assistance-lib": "/content-assistance-lib/static-1.7436",
  "dashboard-lib": "/dashboard-lib/static-1.80591",
  "ExportDialog": "/ExportDialog/static-6.10177",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17584",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17576",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8482",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8251",
  "feedback-loader": "/feedback-loader/static-1.28839",
  "onboarding-scopes": "/onboarding-scopes/static-1.6253",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4439",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.130",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4305",
  "nav-client-types": "/nav-client-types/static-1.2147",
  "purchase-motions-api": "/purchase-motions-api/static-1.5475",
  "trials-service-types": "/trials-service-types/static-1.3706",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.516",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.477",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16979",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12802",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5379",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7578",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10163",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31088",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10827",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6329",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.222",
  "customer-data-tracking": "/customer-data-tracking/static-1.6671",
  "products-iframe-lib": "/products-iframe-lib/static-1.7290",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9842",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8535",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3944",
  "video-components-external": "/video-components-external/static-1.10539",
  "video-data-lib": "/video-data-lib/static-1.34197",
  "directed-graph": "/directed-graph/static-1.727",
  "event-emitter": "/event-emitter/static-1.737",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5309",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9543",
  "fsm": "/fsm/static-1.3521",
  "policy-lib": "/policy-lib/static-1.6576",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9606",
  "navigation-messaging": "/navigation-messaging/static-1.6566",
  "FileManagerLib": "/FileManagerLib/static-1.38501",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8887",
  "FileManagerCore": "/FileManagerCore/static-1.38360",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12019",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10994",
  "react-codemirror": "/react-codemirror/static-1.10417",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9679",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13848",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8485",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27922",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8359",
  "payment-link-components": "/payment-link-components/static-1.22921",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23892",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2987",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2790",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34999",
  "sales-views-client-types": "/sales-views-client-types/static-1.4080",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3443",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11422",
  "content-media-compositions": "/content-media-compositions/static-2.15429",
  "media-bridge-lib": "/media-bridge-lib/static-1.18550",
  "trellis-story-utils": "/trellis-story-utils/static-1.4313",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5600",
  "FileManagerImages": "/FileManagerImages/static-1.36012",
  "video-components": "/video-components/static-1.12542",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4323",
  "video-embed": "/video-embed/static-1.35031",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67672",
  "layout-data-lib": "/layout-data-lib/static-1.9319",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6375",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5707",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4877",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3462",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21294",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3635",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21303",
  "outpost": "/outpost/static-1.3996",
  "advanced-menus-core": "/advanced-menus-core/static-1.14801",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11776",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33405",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14800",
  "simple-menus-lib": "/simple-menus-lib/static-1.16317"
}
};
